import React from 'react';
import '../../styles/components/AsperaDrag.scss';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
import { dragging } from '../../services/DragDropService';
import { language } from '../../services/LanguageService';
/**
 * React Component
 *
 * The AsperaDrag provides the styled drag container that follows the mouse
 *
 * @remarks - DragEvent does not return proper data (not following docs) on Safari
 *
 * @example
 * ```javascript
 * <AsperaDrag />
 * ```
 */
export class AsperaDrag extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: false,
            mainText: '',
            allowed: false,
            xCoordinate: 0,
            yCoordinate: 0,
            alt: false,
        };
        this.subManager = new SubManager();
    }
    getCurrentAction() {
        const { alt, defaultBehavior } = this.state;
        if (defaultBehavior === 'MOVE') {
            return alt ? 'COPY' : 'MOVE';
        }
        else {
            return alt ? 'MOVE' : 'COPY';
        }
    }
    get yCoordinate() {
        var _a;
        const { yCoordinate } = this.state;
        const dragHeight = ((_a = document.querySelector('.aspera-drag')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 110;
        const windowHeight = document.body.offsetHeight || 0;
        if (((yCoordinate || 0) + dragHeight) >= windowHeight) {
            return ((yCoordinate || 0) - dragHeight) - 10;
        }
        else {
            return (yCoordinate || 0) + 10;
        }
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    get xCoordinate() {
        const { xCoordinate } = this.state;
        const dragWidth = 288;
        const windowWidth = document.body.offsetWidth || 0;
        if (((xCoordinate || 0) + dragWidth) >= windowWidth) {
            return ((xCoordinate || 0) - dragWidth) - 10;
        }
        else {
            return (xCoordinate || 0) + 10;
        }
    }
    componentDidMount() {
        this.subManager.setSubscription(dragging.triggerDragState.subscribe({
            next: state => {
                this.setState(state);
            },
            error: error => {
                new AsperaError('AsperaDrag: unable to watch for drag state changes', error);
            },
        }));
    }
    render() {
        const { className } = this.props;
        const { icon, mainText, allowed, errorMessage, errorDescription, visible, alt } = this.state;
        const styles = {
            top: `${this.yCoordinate}px`,
            left: `${this.xCoordinate}px`,
        };
        if (!visible) {
            return null;
        }
        return (React.createElement("div", { className: `aspera-drag ${className ? className : ''}`, style: styles, "data-auto": "drag-wrapper" },
            !!icon && React.createElement("div", { className: "icon" }, React.createElement(icon)),
            React.createElement("div", { className: "primary-content" },
                React.createElement("div", { className: "primary" },
                    this.getCurrentAction() === 'MOVE' ? language.get('table.moving') : language.get('table.copying'),
                    ": ",
                    mainText),
                allowed
                    ? (!alt ? React.createElement("div", { className: "secondary" }, language.getStyled(this.getCurrentAction() === 'MOVE' ? 'table.holdAltToCopy' : 'table.holdAltToMove')) : null)
                    : React.createElement("div", { className: "secondary" },
                        React.createElement("span", { className: "error-text" }, errorMessage),
                        errorDescription))));
    }
}
